import EcommerceFooter from '../../components/ecommerce/EcomFooter'
import NavBar from '../../components/landing/NavBar'
import { Outlet } from 'react-router-dom'

export default function LandingPageLayout() {
  return (
    <div className="">
      <NavBar />
      <Outlet />{' '}
      {/* Outlet will render either landing page content or TermsPrivacy */}
      <EcommerceFooter />
    </div>
  )
}
